<template>
    <div class="user-edit">
        <h2 class="page-title">Group                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    - <span class="fw-semi-bold">Detail</span></h2>
        <Widget :title="(isNew ? 'New' : 'Edit') + ' group'">
            <Loader v-if="!isNew && isReceiving" :size="40"></Loader>
            <Form v-else>
                <div class="form-group row">
                    <label class="col-md-2" for="name">Group name</label>
                    <div class="col-md-5">
                        <input class="form-control" id="name" type="text" :value="group.name"  @change="updateGroupProperty($event, 'name')"/>
                    </div>
                </div>
                <UserSelector :items="group.userIds"/>

                <b-alert class="alert-sm w-25" variant="danger" :show="errorsList.length > 0" :key="error"
                         v-for="error in errorsList">
                    {{error}}
                </b-alert>
                <b-button-toolbar>
                    <b-button variant="success"
                              @click="saveGroup()">
                        <Loader v-if="isUpdating"></Loader>
                        <span v-else>Save</span>
                    </b-button>

                    <b-button variant="default" @click="goBack()">
                        Back
                    </b-button>

                </b-button-toolbar>
            </Form>
        </Widget>
    </div>
</template>


<script>
    import {mapActions, mapState} from "vuex";
    import moment from "moment-timezone";
    import {firestore} from "../../../main";
    import Loader from "../../../components/Loader/Loader";
    import vSelect from "vue-select";
    import UserSelector from "../../../components/UserSelector/UserSelector";


    export default {
        name: "EditGroup",
        components: {UserSelector, Loader, vSelect },
        data(){
            return {
                showAddCountry: false,
                errorsList: [],
                name: "",
                userIds: [],
                selectedCountryId: null,
                user: JSON.parse(localStorage.getItem('user') || {}),
            }
        },
        computed: {
            ...mapState("auth", ["currentUser"]),
            ...mapState("groups", ["isReceiving", "isUpdating", "groups"]),
            ...mapState("users", ["selectedUsers"]),
            ...mapState("countries", ["selectedCountry", "countries"]),
            isNew() {
                var ret = this.getId() == -1;
                return ret;
            },
            group() {
                return this.findGroup(this.getId()) || {}
            }
        },
        watch: {
            selectedCountry(val, oldVal) {
                if(oldVal != undefined && oldVal != null && oldVal.id != val.id) {
                    this.goBack();
                    return;
                }
                this.getGroupsByTenantRequest(val.id);
                this.selectedCountryId = val.id;
                this.getUsersByTenantRequest(val.id);

            }
        },
        async mounted() {
            if (this.currentUser == undefined || this.currentUser.id == null) {
                await this.fetchCurrentUser();
            }
            if(this.selectedCountry != undefined && this.selectedCountry != null && this.selectedCountryId != this.selectedCountry.id) {
                this.selectedCountryId = this.selectedCountry.id;
                await this.getUsersByTenantRequest(this.selectedCountryId);
            }
            if(this.isNew) {

            }
        },
        methods: {
            ...mapActions("auth", ["fetchCurrentUser"]),
            ...mapActions("groups", ["createGroupRequest", "getGroupsRequest", "updateGroupRequest","getGroupsByTenantRequest"]),
            ...mapActions("users", ["getUsersByTenantRequest", "selectUsers"]),
            updateGroupProperty(value, key) {
                let group = this.group;

                group[key] = value.target.value;
            },
            getId() {
                if(this.$route.params.id == "create")
                    return -1;
                return this.$route.params.id || -1;
            },
            findGroup(id) {
                let group = this.groups ? this.groups.find(c => c.id === id) : null
                return group;
            },
            async saveGroup(){
                this.errorsList = [];

                debugger;
                if(this.selectedUsers == null || this.selectedUsers.length == 0 ){
                    this.errorsList.push('Group must contain some users!')
                }
                if(this.selectedCountryId == null){
                    this.errorsList.push('Group must have a country selected!')
                }
                if(this.group.name == null || this.group.name == "") {
                    this.errorsList.push('Missing group name!')
                }
                if(this.errorsList.length == 0) {

                    if (this.isNew) {
                        this.group.users = this.selectedUsers;
                        this.group.tenantId = this.selectedCountryId;
                        await this.createGroupRequest({
                            group: this.group,
                            $toasted: this.$toasted,

                        })
                        this.$router.replace('/app/admin-console/groups');
                    } else {
                        this.group.users = this.selectedUsers;
                        await this.updateGroupRequest({
                            group: this.group,
                            $toasted: this.$toasted,
                            id: this.group.id
                            }
                        )
                    }
                }
                if(true)
                    return;

                const existingCountryWithSameCode = await firestore.collection('countries')
                    .where("code", "==", this.country.code).get()
                const existingCountryWithSameADCode = await firestore.collection('countries')
                    .where("adCode", "==", this.country.adCode).get()
                if(this.isNew && existingCountryWithSameCode.docs.length > 0){
                    this.errorsList.push('Country code must be unique!')
                } else if (!this.isNew && existingCountryWithSameCode.docs.length > 0){
                    const existingCountry = existingCountryWithSameCode.docs[0]
                    if(existingCountry.id != this.country.id){
                        this.errorsList.push('Country code must be unique!')
                    }
                }

                if(this.isNew && existingCountryWithSameADCode.docs.length > 0){
                    this.errorsList.push('AD code must be unique!')
                } else if (!this.isNew && existingCountryWithSameADCode.docs.length > 0){
                    const existingCountry = existingCountryWithSameADCode.docs[0]
                    if(existingCountry.id != this.country.id){
                        this.errorsList.push('AD code must be unique!')
                    }
                }

                if(this.errorsList.length == 0) {
                    if(this.isNew) {
                        await this.createGroupRequest({
                            country: {
                                name: this.country.name,
                                code: this.country.code,
                                adCode: this.country.adCode,
                                timezone: this.country.timezone
                            },
                            $toasted: this.$toasted
                        })
                    } else {
                        await this.updateCountryRequest({
                            id: this.country.id,
                            country: {
                                name: this.country.name,
                                code: this.country.code,
                                adCode: this.country.adCode,
                                timezone: this.country.timezone
                            },
                            $toasted: this.$toasted
                        })
                    }
                }
            },
            findCountry(id) {
                let country = this.countries ? this.countries.find(c => c.id === id) : null
                return country;
            },
            goBack() {
                this.$router.replace('/app/admin-console/groups');
            },
            getTimezoneOptions(){
                return moment.tz.names();
            },
        },
            // await this.getCountriesRequest();
    }
</script>


